<app-page-header title="Tenant Definition" subtitle="Manage tenant organizations and their configurations">
    <div actions class="flex gap-2">
        <p-iconfield>
            <p-inputicon class="pi pi-search" />
            <input type="text" pInputText placeholder="Search" (input)="onGlobalSearch($event)" />
        </p-iconfield>
        <p-button label="Add New" (click)="openCreate()" icon="pi pi-plus"></p-button>
    </div>
</app-page-header>

<div class="table-card">
    <p-table
        #dt
        [value]="tenants"
        [loading]="loading"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50]"
        [scrollable]="true"
        scrollHeight="flex"
        dataKey="id"
        [rowHover]="true"
        [globalFilterFields]="['name']"
    >
        <ng-template #header>
            <tr>
                <th pSortableColumn="id" class="col-sortable">ID <p-sortIcon field="id" /></th>
                <th pSortableColumn="name" class="text-left">
                    <div class="flex items-center gap-2">
                        Name
                        <p-sortIcon field="name"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="name" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="active" class="text-left w-[120px]">
                    <div class="flex items-center gap-2">
                        Status
                        <p-sortIcon field="active"></p-sortIcon>
                    </div>
                </th>
                <th class="w-[80px]"></th>
            </tr>
        </ng-template>
        <ng-template #body let-row>
            <tr>
                <td>{{ row.id }}</td>
                <td>{{ row.name }}</td>
                <td>
                    <span [ngClass]="row.active ? 'status-badge status-active' : 'status-badge status-inactive'">
                        {{ row.active ? 'Active' : 'Inactive' }}
                    </span>
                </td>
                <td class="text-right">
                    <p-button [text]="true" severity="secondary" icon="pi pi-pencil" (click)="openEdit(row)"></p-button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-dialog
    [header]="isEditMode ? 'Edit Tenant' : 'New Tenant'"
    [(visible)]="dialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '450px' }"
>
    <form [formGroup]="tenantForm" (ngSubmit)="saveTenant()">
        <div class="flex flex-col gap-4">
            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Name *</label>
                <input
                    type="text"
                    pInputText
                    placeholder="Enter tenant name"
                    formControlName="name"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('name') }"
                />
                @if (isInvalid('name')) {
                    <small class="text-red-500" *ngIf="tenantForm.get('name')?.errors?.['required']">Name is required.</small>
                    <small class="text-red-500" *ngIf="tenantForm.get('name')?.errors?.['maxlength']"
                        >Name cannot exceed 255 characters.</small
                    >
                }
            </div>

            @if (isEditMode) {
                <div class="flex items-center gap-2">
                    <p-toggleswitch formControlName="active" inputId="activeToggle"></p-toggleswitch>
                    <label for="activeToggle">Active</label>
                </div>
            }
        </div>
    </form>
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" variant="outlined" (click)="cancelDialog()"></p-button>
            <p-button [label]="isEditMode ? 'Update' : 'Create'" (click)="saveTenant()"></p-button>
        </div>
    </ng-template>
</p-dialog>
